import { Type } from "@sinclair/typebox";
import SchemaValidator from "../schema-validator";

const installation = new SchemaValidator(
	Type.Object({
		id: Type.String(),
		platform: Type.Union([Type.Literal("extension"), Type.Literal("lockdown"), Type.Literal("mobile")]),
		version: Type.String(),
		fingerprint: Type.String(),
		details: Type.Object({}),
	}),
);

export default {
	installation,
};
